var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_2579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58872 0.72535L10.705 5.0134L15.4372 5.70102C15.9757 5.77924 16.1907 6.44102 15.801 6.82086L12.3768 10.1586L13.1851 14.8716C13.2771 15.4079 12.7142 15.8169 12.2326 15.5637L7.99997 13.3385L3.76743 15.5637C3.28581 15.8169 2.72287 15.4079 2.81487 14.8716L3.62321 10.1586L0.198974 6.82083C-0.190681 6.44098 0.0243495 5.77927 0.562847 5.70099L5.29498 5.01336L7.41126 0.72535C7.6521 0.237383 8.34788 0.237383 8.58872 0.72535Z",
    fill: "url(#paint0_linear_209_2579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.705 5.01339L8.58872 0.725342C8.46831 0.481375 8.23416 0.359375 8 0.359375V8.47775L10.705 5.01339Z",
    fill: "url(#paint1_linear_209_2579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3768 10.1585L15.801 6.8207C15.9932 6.63333 16.038 6.37742 15.9697 6.15674L7.99997 8.47764L12.3768 10.1585Z",
    fill: "url(#paint2_linear_209_2579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9259 15.5123L7.99997 8.47778V13.3386L12.2325 15.5638C12.4742 15.6908 12.7363 15.6511 12.9259 15.5123Z",
    fill: "url(#paint3_linear_209_2579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 8.47778L3.62317 10.1587L2.81486 14.8717C2.76902 15.1389 2.88583 15.3744 3.07405 15.5123L7.99997 8.47778Z",
    fill: "url(#paint4_linear_209_2579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0302429 6.15692L7.99996 8.47779L5.29497 5.01343L0.562835 5.70108C0.289992 5.74071 0.10043 5.93024 0.0302429 6.15692Z",
    fill: "url(#paint5_linear_209_2579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62321 10.1587L0.198969 6.82095C0.00675133 6.63357 -0.0380922 6.37767 0.0302512 6.15698L7.99997 8.47785L3.62321 10.1587Z",
    fill: "url(#paint6_linear_209_2579)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_2579",
    x1: 8.00024,
    y1: 2.14152,
    x2: 8.00024,
    y2: 19.7957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#FFC954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_2579",
    x1: 12.147,
    y1: 4.41814,
    x2: 6.8102,
    y2: 4.41814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_2579",
    x1: 13.0587,
    y1: 12.5947,
    x2: 11.6453,
    y2: 5.63453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_209_2579",
    x1: 6.20551,
    y1: 16.2526,
    x2: 11.741,
    y2: 10.7171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_209_2579",
    x1: 2.25806,
    y1: 9.25245,
    x2: 6.33817,
    y2: 12.6659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_209_2579",
    x1: 5.31666,
    y1: 3.6219,
    x2: 3.66328,
    y2: 8.31537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_209_2579",
    x1: 11.5404,
    y1: 4.1121,
    x2: -0.606606,
    y2: 9.28557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_2579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.10e46c9fb42124d92c761b6b23af3913.svg";
export { ForwardRef as ReactComponent };